import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Input,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
  DatePicker,
  Table,
  Spin,
  Popconfirm,
  message,
  Space,
} from "antd";

import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import Page from "_components/Page";
import { stockReceiptService, companyService, taxTypeService } from "_services";
import { Auth } from "_helpers";
import AddMaterialDrawer from "./Drawer";
import { CurrencyFormatter } from "_helpers/formatters";
import { ReceiptType } from "_helpers";

function TiepAdd({ history, match }) {
  const [stores, setStores] = useState([]);
  const [storeAddresses, setStoreAddresses] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [customerAddresses, setcustomerAddresses] = useState([]);
  const [orderLines, setOrderLines] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [editDrawerVisible, setEditDrawerVisible] = useState(false);
  const [selectedLine, setSelectedLine] = useState(null);
  const [taxTypes, setTaxTypes] = useState([]);

  const [form] = Form.useForm();
  const { Option } = Select;

  const isLoggedInCustomer = () => {
    return Auth.hasRole(Auth.getProfile(), ["CAU"]);
  };

  useEffect(() => {
    // //stop refresh the site while editing
    // const unloadCallback = (event) => {
    //   const e = event || window.event;
    //   //console.log(e)
    //   e.preventDefault();
    //   if (e) {
    //     e.returnValue = "";
    //   }
    //   return "";
    // };

    // window.addEventListener("beforeunload", unloadCallback);
    getTaxTypes();
    getStores();
    getSuppliers();
    let companyId = Auth.getProfile().comp_id;
    companyService.getById(companyId).then((data) => {
      const grantedStoreAddresses = data.content.addresses; //.filter((item) => item.addressType === "WAREHOUSE");
      // const officeAddresses = data.content.addresses.filter(
      //   (item) => item.addressType === "OFFICE"
      // );
      // form.setFieldsValue({
      //   storeAddress:
      //     grantedStoreAddresses.length === 1 ? grantedStoreAddresses[0] : null,
      //   customer: data.content,
      //   customerAddress: officeAddresses[0],
      // });
      setStoreAddresses(grantedStoreAddresses);
      // setcustomers([data.content]);

      // setcustomerAddresses(officeAddresses);
      //setSelectedcustomer(data.content);
    });
    //getSuppliers();

    // return () => {
    //   //cleanup function
    //   window.removeEventListener("beforeunload", unloadCallback);
    // };
  }, []);

  const setId = (selected, option, idField) => {
    form.setFieldValue(idField, option?.key);
  };

  const getStoreAddresses = (companyId) => {
    form.resetFields(["storeAddress"]);

    companyService.getById(companyId).then((x) => {
      setStoreAddresses(x.content.addresses);
      // setStoreAddresses(
      //   x.content.addresses.filter(
      //     (address) => address.addressType === "WAREHOUSE"
      //   )
      // );
    });
  };

  const getTaxTypes = () => {
    taxTypeService
      .getAll()
      .then((data) => {
        setTaxTypes(data.content);
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getcustomerAddresses = (companyId) => {
    form.resetFields(["customerAddress"]);
    companyService.getById(companyId).then((x) => {
      setcustomerAddresses(
        x.content.addresses.filter(
          (address) => address.addressType === "OFFICE"
        )
      );
    });
  };

  const getStores = () => {
    companyService.getSuggestion("?companyType=STORE").then((x) => {
      if (x.content.length === 1) {
        form.setFieldsValue({
          store: x.content[0],
        });
        getStoreAddresses(x.content[0].id);
        setId(x.content[0].name, { key: x.content[0].id }, "storeID");
      }
      setStores(x.content);
    });
  };

  const getSuppliers = () => {
    companyService.getSuggestion("?companyType=SUPPLIER").then((x) => {
      if (x.content.length === 1) {
        form.setFieldsValue({
          customer: x.content[0],
        });
        getcustomerAddresses(x.content[0].id);
        setId(x.content[0].name, { key: x.content[0].id }, "customerID");
      }
      setcustomers(x.content);
    });
  };

  const handleFormSumbit = () => {
    const payload = {
      vehicleDetails: {
        deliveryNote: "DN-12345",
        sealNumber: "SN-98765",
        tellerNumber: "TN-112233",
        containerNumber: "CN-45678",
        driverName: "dssdsdsd",
        contactNumber: "sdsdsdsds",
        driverNic: "NIC123456",
      },
      receiptType: "LOCAL",
      orderDate: null,
      expectedDate: null,
      receivedDate: null,
      remark: "remark",
      store: { id: null },
      storeAddress: { id: null }, //not nullable
      customer: { id: null },
      customerAddress: { id: null }, //not nullable
      packingStatus: "NEW",
      receivingPerson: null,
      refNumber: null,
      customRefNumber: null,
      currency: { id: null },
      stockReceiptLines: [
        {
          stockType: { id: null },
          measurementType: { id: null },
          acceptedQuantity: null,
          packingType: { id: null },
          itemQuantity: null,
          quantityPerItem: null,
          netWeight: null,
          grossWeight: null,
          quantity: null,
          liabilityAmount: null,
        },
      ],
    };

    form
      .validateFields()
      .then((values) => {
        setIsLoading(true);
        payload.receiptType = values.receiptType;
        payload.receivedDate = moment(values.receivedDate).format("YYYY-MM-DD");
        payload.customer = { id: values.customerID };
        payload.customerAddress = { id: values.customerAddressID }; //not nullable
        payload.store = { id: values.storeID };
        payload.storeAddress = { id: values.storeAddressID };
        payload.customRefNumber = values.customRefNumber;
        payload.receivingPerson = values.recievingPerson;

        payload.stockReceiptLines = orderLines.map((line) => ({
          ...line,
          innerQuantity: line.quantity,
          packageQuantity: line.quantity,
          tiepPackageQuantity: line.quantity,
          tiepQuantityPerPackage: line.quantityPerItem,
          //packagesPerStorageUnit: line.quantityPerItem,
        }));

        stockReceiptService
          .manualAdd(payload)
          .then((response) => {
            message.success("Successfully Uploaded!");
            history.push("/stock-receipts");
            setIsLoading(false);
          })
          .catch((error) => {
            setError(error);
            message.error(error, 3);
            setIsLoading(false);
          });
      })
      .catch((error) => {
        setError(error);
        message.error(error);
        setIsLoading(false);
      });
  };

  const onCancel = () => {
    history.push(".");
  };

  const getRowBykey = (key, newData) => {
    return (orderLines || newData).filter((item) => item.key === key)[0];
  };

  const handleDelete = (record) => {
    const currentLines = [...orderLines];
    const newLines = currentLines.filter(
      (item) => item.stockType.id != record.stockType.id
    );

    setOrderLines(newLines);
  };

  const handleAddOrderLine = () => {
    setSelectedLine(null);
    setEditDrawerVisible(true);
  };

  const handleStockItemEdit = (record) => {
    setSelectedLine(record);
    setEditDrawerVisible(true);
  };

  const orderLineColumns = [
    {
      title: "Hscode",
      dataIndex: ["stockType", "code"],
      key: "hscode",
      width: "5%",
      render: (text, record) => {
        return text ?? "";
      },
    },

    {
      title: "Item No#",
      dataIndex: ["itemNumber"],
      key: "itemNumber",
      width: "5%",
      render: (text, record) => {
        return text ?? "";
      },
    },

    {
      title: "Description",
      dataIndex: ["stockType", "name"],
      key: "material",
      align: "center",
      width: "15%",
    },

    {
      title: "Package Type",
      dataIndex: ["packingType", "name"],
      key: "packingType",
      align: "center",
      width: "5%",
      render: (text, record) => {
        return text ?? "";
      },
    },

    {
      title: "Quantity Of Packages",
      dataIndex: "quantity",
      key: "numberOfUnits",
      align: "center",
      width: "5%",
      render: (text, record) => {
        return text ?? "";
      },
    },

    {
      title: "UOM",
      dataIndex: ["measurementType", "name"],
      align: "center",
      key: "uom",
      width: "5%",
      render: (text, record) => {
        return text ?? "";
      },
    },

    {
      title: "VAT",
      dataIndex: ["vat"],
      align: "center",
      key: "vat",
      width: "5%",
      render: (text, record) => CurrencyFormatter(text ?? ""),
    },

    {
      title: "Duty",
      dataIndex: ["totalDuty"],
      align: "center",
      key: "totalDuty",
      width: "5%",
      render: (text, record) => CurrencyFormatter(text ?? ""),
    },

    ...taxTypes.map((taxType) => ({
      title: taxType.code,
      dataIndex: ["stockReceiptLineTaxes"],
      align: "center",
      key: taxType.code,
      width: "5%",
      render: (text, record) => {
        const taxLine = record.stockReceiptLineTaxes.find(
          (tax) => tax.taxType.code === taxType.code
        );
        return taxLine.taxAmount;
      },
    })),

    {
      title: "",
      key: "action",
      width: "6%",
      render: (text, record) => {
        return (
          <Space>
            <Button
              icon={<EditOutlined />}
              title="Edit"
              type="link"
              style={{ marginRight: 10 }}
              onClick={() => handleStockItemEdit(record)}
            ></Button>

            <Button
              icon={<DeleteOutlined />}
              title="Delete"
              type="link"
              style={{ marginRight: 10 }}
              onClick={() => handleDelete(record)}
            ></Button>
          </Space>
        );
      },
    },
  ];

  const onCloseAddEditStockItemDrawer = () => {
    setEditDrawerVisible(false);
  };

  const handleDrawerSubmit = (data) => {
    console.table(data);
    setIsLoading(true);

    setOrderLines((prevOrderLines) => {
      const newOrderLines = prevOrderLines.filter(
        (item) => item.stockType.id !== data.stockType.id
      );
      return [...newOrderLines, { ...data }];
    });

    setIsLoading(false);
    setEditDrawerVisible(false);
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Stock Receipts Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts/add">Add Stock</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={[
          <Popconfirm
            title="Are you sure to add the changes?"
            onConfirm={handleFormSumbit}
            key="add-confirm"
            disabled={orderLines?.length == 0}
          >
            <Button
              key="1"
              type="primary"
              htmlType="submit"
              loading={isLoading}
              disabled={orderLines?.length == 0}
            >
              Save
            </Button>
          </Popconfirm>,
          <Button key="2" htmlType="button" onClick={onCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Page inner error={error}>
          <Spin tip="Loading..." spinning={isLoading}>
            {/* <AddReciptTabMenu menu="add" /> */}

            <Form
              layout="vertical"
              form={form}
              name="form-create"
              requiredMark={true}
              onValuesChange={(changedValues, allValues) => {
                const receiptType = allValues.receiptType;
                let prefix = "";
                // DIRECT -> TIEP, INDIRECT -> LOCAL
                if (receiptType === "TIEP") prefix = "S";
                else if (receiptType === "LOCAL") prefix = "H";

                if (prefix) {
                  const currentRef = allValues.customRefNumber || "";

                  if (changedValues.receiptType) {
                    // Changing type: Replace the first character with new prefix
                    form.setFieldsValue({
                      customRefNumber:
                        prefix +
                        (currentRef.length > 0 ? currentRef.substring(1) : ""),
                    });
                  } else if (changedValues.customRefNumber !== undefined) {
                    // Changing text: Enforce prefix exists at start
                    if (!currentRef.startsWith(prefix)) {
                      form.setFieldsValue({
                        customRefNumber: prefix + currentRef,
                      });
                    }
                  }
                }
              }}
            >
              <Row gutter={24}></Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["receiptType"]}
                    label="Receipt Type"
                    rules={[
                      { required: true, message: "There should be a Type" },
                    ]}
                  >
                    <Select>
                      {ReceiptType.map((item) => (
                        <Select.Option value={item.value} key={item.value}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name={["customer"]}
                    rules={[
                      { required: true, message: "There should be a Supplier" },
                    ]}
                    label="Supplier"
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder="Please select"
                      onChange={(selected, option) => {
                        if (option) {
                          getcustomerAddresses(option.key);
                        } else {
                          setcustomerAddresses([]);
                        }
                        setId(selected, option, "customerID");
                      }}
                      allowClear
                    >
                      {customers.length > 0 &&
                        customers.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["store"]}
                    rules={[{ required: true }]}
                    label="Store"
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      placeholder="Please select"
                      onChange={(selected, option) => {
                        if (option) {
                          getStoreAddresses(option.key);
                        } else {
                          setStoreAddresses([]);
                        }
                        setId(selected, option, "storeID");
                      }}
                      allowClear
                    >
                      {stores.length > 0 &&
                        stores.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.name}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={"recievingPerson"}
                    rules={[
                      {
                        required: true,
                        message: "There should be a recieved person",
                      },
                    ]}
                    label="Received Person"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                {/* <Col span={6}>
                  <Form.Item
                    name={["totalInvoiceAmount"]}
                    rules={[
                      { required: true, message: "There should be a amount" },
                    ]}
                    label="Total Invoiced Amount"
                  >
                    <Input type="number"></Input>
                  </Form.Item>
                </Col> */}
              </Row>

              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    name={["customRefNumber"]}
                    rules={[{ required: true }]}
                    label="Custom's Declaration Number / GRN Number"
                  >
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["customerAddress"]}
                    rules={[{ required: true }]}
                    label="Supplier Address"
                  >
                    <Select
                      placeholder="Please select"
                      onChange={(selected, option) =>
                        setId(selected, option, "customerAddressID")
                      }
                      allowClear
                    >
                      {customerAddresses.length > 0 &&
                        customerAddresses.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.address || t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item
                    name={["storeAddress"]}
                    rules={[
                      {
                        required: true,
                        message: "There should be a Store Address",
                      },
                    ]}
                    label="Store Address"
                  >
                    <Select
                      placeholder="Please select"
                      onChange={(selected, option) =>
                        setId(selected, option, "storeAddressID")
                      }
                      allowClear
                    >
                      {storeAddresses.length > 0 &&
                        storeAddresses.map((t) => (
                          <Option value={t.name} key={t.id}>
                            {t.address || t.code}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* <Col span={6}>
                  <Form.Item
                    name={["orderDate"]}
                    rules={[{ required: false }]}
                    label="Customer Declaration Date"
                  >
                    <DatePicker
                      placeholder="Customer Declaration Date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col> */}

                <Col span={6}>
                  <Form.Item
                    name={["receivedDate"]}
                    rules={[{ required: true }]}
                    label="Received Date"
                  >
                    <DatePicker
                      placeholder="Received date"
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item name="storeID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>

                <Col span={6}>
                  <Form.Item name="customerID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="storeAddressID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="customerAddressID" hidden>
                    <Input></Input>
                  </Form.Item>
                </Col>
              </Row>
              <Button
                style={{
                  width: "100%",
                  color: "black",
                  fontWeight: "bold",
                  marginTop: 16,
                  marginBottom: 8,
                  background: "rgb(190, 200, 200)",
                }}
                type="dashed"
                onClick={handleAddOrderLine}
                icon={<PlusOutlined />}
              >
                Add Item
              </Button>

              <AddMaterialDrawer
                onDrawerClose={onCloseAddEditStockItemDrawer}
                isDrawerOpen={editDrawerVisible}
                title="Add Material"
                finishSubmit={handleDrawerSubmit}
                isloading={isLoading}
                initialValues={selectedLine ?? null}
              />

              {orderLines && (
                <Table
                  bordered
                  pagination={false}
                  columns={orderLineColumns}
                  dataSource={orderLines}
                  size="small"
                />
              )}
            </Form>
          </Spin>
        </Page>
      </PageHeader>
    </div>
  );
}

export default TiepAdd;
